const Heros = (($) => {
  let _els = {};
  let _headerHeight;

  const init = () => {
    gsap.registerPlugin(ScrollTrigger);

    _initScroll();
    _initHeroRotator();
  };

  const _initScroll = () => {
    _els.header = $('#primary-header .navbar');
    _els.heroLogo = $('.hero__content svg');

    // should we use pin? Disable on Project Serve
    var doPin = ( $('body').hasClass('page-project-serve') ) ? false : true;

    _headerHeight = _els.header.outerHeight();
    let headerHeightPercent = 1 - _headerHeight / window.innerHeight;

    const heroTl = gsap.timeline({
      scrollTrigger: {
        trigger: '.hero',
        start: 'top top',
        scrub: true,
        pin: true,
        pinSpacing: false,
        onUpdate: (self) => {
          if (self.progress >= headerHeightPercent) {
            _els.header.removeClass('navbar-dark');
            _els.header.addClass('navbar-light');
          } else {
            _els.header.addClass('navbar-dark');
            _els.header.removeClass('navbar-light');
          }
        },
      },
    });

    heroTl.to(
      _els.heroLogo,
      {
        opacity: 0.5,
        // scale: 1.25,
        y: '-=75',
        ease: 'power2.inOut',
      },
      '+=0.0',
    );
  };

  const _initHeroRotator = () => {
    _els.heroRotators = $('.hero__bg__images');

    // return if none found
    if (_els.heroRotators.length < 1) return;

    // loop to handle multiple
    $.each(_els.heroRotators, (i, val) => {
      let $this = $(val);
      let $slides = $this.find('.image');
      let numItems = $slides.length;
      let currentIndex = 0;
      let itemInterval = 5000;

      // show the first item
      $slides.eq(currentIndex).addClass('active');

      // loop through the images
      setInterval(() => {
        // hide current
        $slides.eq(currentIndex).removeClass('active');

        // increment
        if(currentIndex === numItems - 1) {
          currentIndex = 0;
        } else {
          currentIndex++;
        }

        // show next
        $slides.eq(currentIndex).addClass('active');
      }, itemInterval);
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
